import { observable } from "mobx";
import ReportRequestStatus from "./reportRequestStatus";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class CreateExternalReportResponse {
  @observable
  reportRequestId?: string;

  @observable
  reportStatus!: ReportRequestStatus;
}
